import request from '../utils/request';

export function getAppTree(params) {
  return request.get('/app/tree', { params });
}

export function getAppList(params) {
  return request.get('/app/list', { params });
}

export function createApp(data) {
  return request.post('/app/create', data);
}

export function updateApp(data) {
  return request.put('/app/update', data);
}

export function deleteApp(id) {
  return request.delete('/app/delete', { params: { id } });
}

/**
 * 查看应用密钥（仅管理员）
 * 独立于列表接口，列表返回的 app 对象里不含 app_secret
 */
export function getAppSecret(id) {
  return request({ url: '/app/secret', method: 'get', params: { id } });
}

/**
 * 重置应用密钥（仅管理员）
 * 返回新的 app_secret；旧密钥立即失效
 */
export function resetAppSecret(id) {
  return request({ url: '/app/reset-secret', method: 'post', data: { id } });
}